import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
  >
    <path
      fill="none"
      stroke="#D6434F"
      strokeLinejoin="bevel"
      strokeWidth="3.75"
      d="M1100,2936.41889 L1108.98169,2933.42499 C1109.57914,2933.22584 1110.23138,2933.27353 1110.79351,2933.55746 C1113.24412,2934.79527 1115.95245,2935.43672 1118.70317,2935.42955 C1125.41165,2935.42696 1131.54314,2931.63511 1134.54673,2925.62538 C1135.78454,2923.17477 1136.42599,2920.46644 1136.41883,2917.72097 L1136.42241,2916.66394 C1135.92634,2907.67224 1128.74665,2900.49255 1119.88506,2900.00007 L1118.69792,2900.00006 C1115.95245,2899.9929 1113.24412,2900.63435 1110.78455,2901.87666 C1104.78378,2904.87575 1100.99193,2911.00724 1100.98933,2917.72097 C1100.98217,2920.46644 1101.62362,2923.17477 1102.86143,2925.62538 C1103.14536,2926.18751 1103.19305,2926.83975 1102.9939,2927.4372 L1100,2936.41889 Z"
      transform="translate(-1098 -2898)"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/tour/assets/Discussion_Red.js